<ng-container *transloco="let t; prefix: 'widgets.options'" [formGroup]="form">
  <xi-dropdown
    select="single"
    formControlName="timeInterval"
    [placeholder]="t('select-time-interval')"
    [label]="t('time-interval')"
    [stretch]="true"
    [data]="timeIntervalOptions()"
  ></xi-dropdown>
</ng-container>
